import {Component, ChangeDetectionStrategy} from '@angular/core';
import {ReactiveFormsModule} from "@angular/forms";
import {Dialog} from '../../../../../interfaces/dialog/dialog';
import {DialogParams} from '../../../../../interfaces/dialog/dialog-params';
import {ConversionService} from '../../../../../services/conversion/conversion.service';
import {lastValueFrom} from 'rxjs';
import {ProgressBarComponent} from '../../../../layout/progress-bar/progress-bar.component';

import {Conversion} from '../../../../../models/conversion';
import {DialogService} from '../../../../../services/dialog/dialog.service';

@Component({
  selector: 'app-conversion-batch',
  imports: [
    ReactiveFormsModule,
    ProgressBarComponent
],
  templateUrl: './conversion-batch.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './conversion-batch.component.scss'
})
export class ConversionBatchComponent implements Dialog {
  batch: any = {};
  progress = 0;
  aborted = false;

  constructor(
    private dialogService: DialogService,
    private conversionService: ConversionService
  ) {
  }

  onDialogInit(params: DialogParams): void {
    params.backdrop = false;
    this.batch = params.data.batch;

    this.run().then(() => {
      this.dialogService.closeDialog();
    });
  }

  async run(): Promise<void> {
    let conversions: number[] = this.batch.conversions;

    let i = 0;
    for (const conversionId of conversions) {
      let conversion = await lastValueFrom(this.conversionService.findOneById(conversionId));

      await this.processConversion(conversion);

      i++;

      this.progress = Math.round(i * 100 / conversions.length);

      if (this.aborted) {
        break;
      }
    }
  }

  async processConversion(conversion: Conversion): Promise<void> {
    if (!conversion.id) {
      return;
    }

    if (conversion.paid) {
      return;
    }

    switch (this.batch.action) {
      case 'accept-conversion':
        await lastValueFrom(this.conversionService.update(conversion.id, {accepted: true}));
        break;
      case 'reject-conversion':
        await lastValueFrom(this.conversionService.update(conversion.id, {accepted: false}));
        break;
      case 'adjust-payout':
        await lastValueFrom(this.conversionService.update(conversion.id, {payout: this.batch.params.payout}));
        break;
    }
  }

  abort(): void {
    this.aborted = true;
  }
}
